export default {
  scroll: 'Scroll',
  discover: 'Discover',
  view: 'View',
  read: 'Leggi',
  download: 'Download',
}
